"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PayoutStatuses = exports.PayoutStatus = void 0;
var PayoutStatus;
(function (PayoutStatus) {
    PayoutStatus[PayoutStatus["Pending"] = 0] = "Pending";
    PayoutStatus[PayoutStatus["Fulfilled"] = 1] = "Fulfilled";
    PayoutStatus[PayoutStatus["Failed"] = 2] = "Failed";
    PayoutStatus[PayoutStatus["Unknown"] = 3] = "Unknown";
    PayoutStatus[PayoutStatus["Approved"] = 4] = "Approved";
    PayoutStatus[PayoutStatus["Declined"] = 5] = "Declined";
    PayoutStatus[PayoutStatus["Processing"] = 6] = "Processing";
})(PayoutStatus || (exports.PayoutStatus = PayoutStatus = {}));
exports.PayoutStatuses = Object.keys(PayoutStatus)
    .filter((key) => !isNaN(Number(key)))
    .map((i) => Number(i));
//# sourceMappingURL=PayoutStatus.js.map